import { Input, Output, EventEmitter } from '@angular/core';
import { WithEditor } from './interfaces';
import { AMapPathOverlay, PathOverlayOptions } from './amap-path-overlay';
import { EventBinderService } from '../shared/event-binder.service';

export const PolygonOptions = [...PathOverlayOptions, 'fillColor', 'fillOpacity', 'path'];

export class AMapPolygon<
  T extends AMap.EventEmitter,
  E extends AMap.EventEmitter
> extends AMapPathOverlay<T> {
  // ---- Options ----
  /**
   * å¤è¾¹å½¢è½®å»çº¿çèç¹åæ æ°ç»
   */
  @Input() path?: AMap.LocationValue[] | AMap.LocationValue[][];
  /**
   * å¤è¾¹å½¢å¡«åé¢è²
   */
  @Input() fillColor?: string;
  /**
   * è¾¹å½¢å¡«åéæåº¦
   */
  @Input() fillOpacity?: number;
  /**
   * é¢å¤: æ¯å¦éè
   */
  @Input() hidden = false;
  /**
   * é¢å¤: æ¯å¦å¼å¯ç¼è¾å¨
   */
  @Input() editor = false;
  /**
   * é¢å¤: ä¼è¦çå¶ä»å±æ§çéç½®æ¹å¼
   */
  @Input() options: AMap.Polygon.Options;

  // directive events:
  @Output() naReady = new EventEmitter();

  // editor events:
  @Output() naEditorAddNode: EventEmitter<any>;
  @Output() naEditorRemoveNode: EventEmitter<any>;
  @Output() naEditorAdjust: EventEmitter<any>;
  @Output() naEditorEnd: EventEmitter<any>;

  constructor(protected os: WithEditor<T, E>, protected binder: EventBinderService) {
    super(os, binder);
    const editor = this.os.getEditor();
    this.naEditorAddNode = this.binder.bindEvent(editor, 'addnode');
    this.naEditorRemoveNode = this.binder.bindEvent(editor, 'removenode');
    this.naEditorAdjust = this.binder.bindEvent(editor, 'adjust');
    this.naEditorEnd = this.binder.bindEvent(editor, 'end');
  }
}
